import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PO_HEADER } from 'src/app/model/PO_HEADER.model';
import { POLine } from 'src/app/model/po-line.model';
import { PoheaderService } from 'src/app/services/poheader.service';
import { VMSUOMMASTERModel } from 'src/app/model/vms-uom-master-model';
import { VMSHSNSACMASTERModel } from 'src/app/model/vms-hsn-sac-master-model';
import { VMSGSTGROUPCODEMASTERModel } from 'src/app/model/vms-gst-group-code-master-model';
import { VMSPLTYPEMASTERModel } from 'src/app/model/vms-pl-type-master-model';
import { VMSNATUREOFEXPENSEMASTERModel } from 'src/app/model/vms-nature-of-expense-master-model';
import { VMSTDSNATUREOFDEDUCTIONMASTERModel } from 'src/app/model/vms-tds-nature-of-deduction-master-model';
import { VMSPIHEADERSTRUCTUREMASTERModel } from 'src/app/model/vms-pi-header-structure-master-model';
import { VMSLOCATIONMASTERModel } from 'src/app/model/vms-location-master-model';
import { ToastrService } from 'ngx-toastr';
import { VMSDEPARTMENTMASTER } from 'src/app/model/vmsdepartmentmaster';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { CrudService } from 'src/app/services/crud.service';
import { formatDate } from '@angular/common';
import { CreditMemoService } from 'src/app/services/credit-memo.service';

@Component({
  selector: 'app-createpurchase',
  templateUrl: './createpurchase.component.html',
  styleUrls: ['./createpurchase.component.css']
})

export class CreatepurchaseComponent implements OnInit {
  files: any[] = [];
  PoheaderModel: PO_HEADER;
  PoheaderList: PO_HEADER[] = [];
  PoLineModel: POLine;
  PoLineList: POLine[] = [];
  MastersList: any;
  LstHSNSACMaster: VMSHSNSACMASTERModel[] = [];
  TempLstHSNSACMaster: VMSHSNSACMASTERModel[] = [];
  LstGSTGroupCodeMaster: VMSGSTGROUPCODEMASTERModel[] = [];
  LstPLTypeMaster: VMSPLTYPEMASTERModel[] = [];
  LstNatureOfExpenseMaster: VMSNATUREOFEXPENSEMASTERModel[] = [];
  LstNatureOfDeductionMaster: VMSTDSNATUREOFDEDUCTIONMASTERModel[] = [];
  TempLstNatureOfDeductionMaster: VMSTDSNATUREOFDEDUCTIONMASTERModel[] = [];
  LstPIHeaderStructureMaster: VMSPIHEADERSTRUCTUREMASTERModel[] = [];
  LstLocationMaster: VMSLOCATIONMASTERModel[] = [];
  LstDepartmentMaster: VMSDEPARTMENTMASTER[] = []; LstUomMaster: VMSUOMMASTERModel[] = [];

  filesToUpload = [];
  FileUpload: any = [];
  PurInvoiceNo: any;
  NetTotal: number = 0;
  TotalGSTAmount: number = 0;
  TotalBaseAmount: number = 0;
  mySubscription: any;
  TotalTDSAmount: number = 0;
  today: any;
  AddressCodeList: any[]=[];
  MinDate: any;
  @ViewChild('fileInput', { static: false })
  myFileInput: ElementRef;
  UserName: string = sessionStorage.getItem("UserName");

  size = 1024 * 1024;
  fileToUpload: any;
  imageUrl: any;
  fileName: string;
  file: File;
  size_limit: boolean = false;

  // DownLoadURL:string='';



  constructor(private POHeaderSer: PoheaderService, private toasterSer: ToastrService,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,
    private router: Router, private CrudSer: CrudService,
    private CreditMemoSer: CreditMemoService) {
    this.today = new Date();
    var date = new Date();
    date.setMonth(date.getMonth() - 1);
    this.MinDate = date;
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    this.mySubscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Trick the Router into believing it's last link wasn't previously loaded
        this.router.navigated = false;
      }
    });
    this.route.queryParams
      .subscribe(params => {
        this.PurInvoiceNo = params['PurInvoiceNo'] || null;
      });
  }
  ngOnDestroy() {
    if (this.mySubscription) {
      this.mySubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.PoheaderModel = new PO_HEADER();
    this.PoLineModel = new POLine();
    this.files = [];
    this.FileUpload = [];

    //  this.GetAllMasters(); 
    if (this.PurInvoiceNo != null) {
      this.GetAllMasters().
        then(res => this.GetPOHeaderDetails(this.PurInvoiceNo));
      //this.GetAllPIDocuments(this.PurInvoiceNo);
    }
    else {
      this.GetAllMasters();
      this.PoheaderModel = new PO_HEADER();
      this.PoheaderModel.PH_STATUS = "DRAFT";
      this.PoLineModel = new POLine();
      this.PoLineList = [];
    }
    this.GetAddressCodes();
  }




  AddPurchaseLine() {
    debugger;
    if (this.validationsHeader()) {
      if (this.ValidationsLine()) {
        if (this.PoLineModel.Index == undefined) {
          this.PoLineModel.PL_NATURE_OF_EXPENSE_DESCRIPTION = this.LstNatureOfExpenseMaster.find(x => x.NUMBER == this.PoLineModel.PL_NATURE_OF_EXPENSE).NAME;
          this.PoLineModel.PL_GST_GROUP_CODE_DESCRIPTION = this.LstGSTGroupCodeMaster.find(x => x.GSTGC_CODE == this.PoLineModel.PL_GST_GROUP_CODE).GSTGC_RATE_PERCENT;
          if (this.PoLineModel.PL_NATURE_OF_DEDUCTION != '') {
            this.PoLineModel.PL_NATURE_OF_DEDUCTION_DESCRIPTION = this.TempLstNatureOfDeductionMaster.find(x => x.CODE == this.PoLineModel.PL_NATURE_OF_DEDUCTION).DESCRIPTION;
          }
          this.PoLineList.push(this.PoLineModel);
        }
        else {
          this.PoLineList.splice(this.PoLineModel.Index, 1, this.PoLineModel);
        }
        this.PoLineModel = new POLine();

      }
    }
    console.log(this.PoLineList);
  }
  DownloadFile(FileName: string) {

    console.log(FileName.replace(/[^a-zA-Z0-9]/g, ''));

    window.open(this.CrudSer.DownLoadURl + 'UploadedFiles/' + this.PoheaderModel.PH_PURCHASE_INVOICE_NO.replace(/[^a-zA-Z0-9]/g, '') + '/' + FileName);
  }

  EditLienItem(item: POLine, Index: any) {
    this.PoLineModel = new POLine();
    this.PoLineModel = item;
    this.PoLineModel.Index = Index;
    this.LstHSNSACMaster = this.TempLstHSNSACMaster;
  }

  GetAddressCodes() {
    this.CreditMemoSer.GetAddressCodes().subscribe(
      res => {

        debugger;
        if (res.Status) {
          debugger;
          // alert(res.Data);
          this.AddressCodeList = res.Data;
          this.AddressCodeList = this.AddressCodeList.filter(x => x.VendorNo.toLowerCase() == this.UserName.toLocaleLowerCase());
          
          
          if(this.AddressCodeList.length>0)
          {
            let gst = this.AddressCodeList.find(x=> x.OrderAddCode.toLowerCase() == x.VendorGSTRegNo.toLowerCase());
            if(gst == undefined || gst == 'undefined')
            {
              let item = this.AddressCodeList[0];
              // item.OrderAddCode = item.VendorGSTRegNo;
              // item.OrderAddCode = item.SupplierGSTINNo = item.VendorGSTRegNo;

              this.AddressCodeList.push({
                OrderAddCode:item.VendorGSTRegNo, 
                SupplierGSTINNo: item.VendorGSTRegNo, 
                VendorGSTRegNo:item.VendorGSTRegNo, 
                VendorNo: item.VendorNo});

              console.log('AddressCodeList-Modified', this.AddressCodeList);

            }

          }
          
          
          





        }
      },
      error => {
        console.log(error);
        //console.error();
      }
    );
  }

  GetPOHeaderDetails(PurchaseInvoiceNo: any) {
        
    //this.GetAllPIDocuments(PurchaseInvoiceNo);
    this.POHeaderSer.GetPurchaseInvoiceByNo(PurchaseInvoiceNo).subscribe(
      res => {
        this.PoheaderModel = res.Data;
        console.log(res.Data);
        debugger;
        console.log(this.PoheaderModel.PH_DOCUMENT_DATE);
        this.PoheaderModel.PH_DOCUMENT_DATE = this.PoheaderModel.PH_DOCUMENT_DATE == null ? "" : this.GetDates(new Date(this.PoheaderModel.PH_DOCUMENT_DATE).toLocaleDateString('en-US'));

        //this.PoheaderModel.PH_DOCUMENT_DATE = this.PoheaderModel.PH_DOCUMENT_DATE == null ? "" : formatDate(this.PoheaderModel.PH_DOCUMENT_DATE, 'dd/MM/yyyy', 'en_US');
        //this.PoheaderModel.PH_DOCUMENT_DATE=formatDate(this.PoheaderModel.PH_DOCUMENT_DATE, 'dd/MM/yyyy', 'en_US');
        this.PoLineList = res.Data.purchase_LineModels;
        this.TotalGSTAmount = this.PoLineList.reduce((sum, current) => sum + current.PL_GST_AMOUNT, 0);
        this.TotalBaseAmount = this.PoLineList.reduce((sum, current) => sum + current.PL_LINE_AMOUNT, 0);
        //this.TotalBaseAmount= this.PoLineList.reduce((sum, current) => sum + current.PL_GST_BASE_AMT, 0);
        this.NetTotal = this.PoLineList.reduce((sum, current) => sum + current.PL_AMOUNT_TO_VENDOR, 0);
        //Number((this.TotalGSTAmount+this.TotalBaseAmount).toFixed(2));
        this.TotalTDSAmount = this.PoLineList.reduce((sum, current) => sum + current.PL_TDS_AMT, 0);

        this.PoLineList.forEach(element => {
          element.PL_NATURE_OF_EXPENSE_DESCRIPTION = this.LstNatureOfExpenseMaster.find(x => x.NUMBER == element.PL_NATURE_OF_EXPENSE).NAME;
          element.PL_GST_GROUP_CODE_DESCRIPTION = this.LstGSTGroupCodeMaster.find(x => x.GSTGC_CODE == element.PL_GST_GROUP_CODE).GSTGC_RATE_PERCENT;
          if (element.PL_NATURE_OF_DEDUCTION != '') {
            element.PL_NATURE_OF_DEDUCTION_DESCRIPTION = this.TempLstNatureOfDeductionMaster.find(x => x.CODE == element.PL_NATURE_OF_DEDUCTION).DESCRIPTION;

          }
        });
        //  this.spinner.hide();
        
        this.GetAllPIDocuments(this.PoheaderModel.PH_PURCHASE_INVOICE_NO);
      },
      error => {
        this.spinner.hide();
        console.log(error);
        console.error();
      }
    );


  }
  ValidationsLine() {
    if (this.PoLineModel.PL_NATURE_OF_EXPENSE == '') {
      this.toasterSer.warning('Please select nature of expense');
      return false;
    }
    else if (this.PoLineModel.PL_QUANTITY == '' || parseInt(this.PoLineModel.PL_QUANTITY) == 0) {
      this.toasterSer.warning('Please enter quantity');
      return false;
    }
    else if (this.PoLineModel.PL_GST_GROUP_CODE == '') {
      this.toasterSer.warning('Please select gst group code');
      return false;
    }
    else if (this.PoLineModel.PL_HSN_SAC_CODE == '') {
      this.toasterSer.warning('Please select HSN SAC code');
      return false;
    }
    else if (this.PoLineModel.PL_DIRECT_UNIT_COST == '' || this.PoLineModel.PL_DIRECT_UNIT_COST == 0) {
      this.toasterSer.warning('Please enter direct unit cost');
      return false;
    }
    // else if(this.PoLineModel.PL_DESCRIPTION==''){
    //   this.toasterSer.warning('Please enter description');
    //   return false;
    // }
    else {
      return true;
    }
  }
  validateEmail(Email) {
    const regularExpression = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regularExpression.test(String(Email).toLowerCase());

  }

  alphaNumberOnly(e) {  // Accept only alpha numerics, not special characters 
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (regex.test(str)) {
      return true;
    }

    e.preventDefault();
    return false;
  }




  validationsHeader() {
    if (this.PoheaderModel.PH_DEPARTMENT == '') {
      this.toasterSer.warning('Please selet department code');
      return false;
    }
    if (this.PoheaderModel.PH_STRUCTURE == '') {
      this.toasterSer.warning('Please selet structure');
      return false;
    }

    if (this.PoheaderModel.PH_DOCUMENT_DATE == '') {
      this.toasterSer.warning('Please selet Invoice Date');
      return false;
    }
    if (this.PoheaderModel.PH_VENDOR_INVOICE_NO == '') {
      this.toasterSer.warning('Please enter vendor invoice number');
      return false;
    }

    var regex = /^[A-Za-z0-9-/]{1,16}$/;
    if (!regex.test(this.PoheaderModel.PH_VENDOR_INVOICE_NO)) {
      this.toasterSer.warning("Invoice Number format Not valid [must be alphanumeric string with '-' or '/' of length 1 to 16 ]");
      return;
    }

    if (this.PoheaderModel.PH_LOCATION_CODE == '') {
      this.toasterSer.warning('Please selet location code');
      return false;
    }
    if (this.PoheaderModel.PH_REMARKS == '') {
      this.toasterSer.warning('Please enter remarks');
      return false;
    }
   

    else {
      return true;
    }
  }

  DeleteLine(index: any) {
    if (confirm('Do you want to delete the Line Item!!')) {

      if (this.PoLineList[index].PL_LINE_NO == undefined || this.PoLineList[index].PL_LINE_NO == '') {
        this.PoLineList.splice(index, 1);
      }
      else {
        this.POHeaderSer.DeletePILine(this.PoheaderModel.PH_PURCHASE_INVOICE_NO, this.PoLineList[index].PL_LINE_NO).subscribe(
          res => {
            if (res.Status) {
              this.GetPOHeaderDetails(this.PurInvoiceNo);
              this.toasterSer.success('Purchase invoice Line has been deleted successfully!!!');
            }
            else {
              this.toasterSer.error(res.Message);
            }
          },
          error => {
            console.log(error);
            console.error();
          }
        );

      }
    }
  }
  parseDate(value: any): Date | null {
    if ((typeof value === 'string') && (value.includes('/'))) {
      const str = value.split('/');

      const year = Number(str[2]);
      const month = Number(str[1]) - 1;
      const date = Number(str[0]);

      return new Date(year, month, date);
    } else if ((typeof value === 'string') && value === '') {
      return new Date();
    }
    const timestamp = typeof value === 'number' ? value : Date.parse(value);
    return isNaN(timestamp) ? null : new Date(timestamp);
  }
  SavePOERP() {
    let formdata = new FormData();

    formdata.append('PoModel', JSON.stringify(this.PoheaderModel));
    for (var i = 0; i < this.FileUpload.length; i++) {

      debugger;
      formdata.append(this.FileUpload[i].name, this.FileUpload[i].file, this.FileUpload[i].name);

    }
    console.log(this.PoheaderModel);


    let promise = new Promise((resolve, reject) => {
      this.POHeaderSer.SavePORecord(formdata).toPromise()
        .then(
          res => {            
            this.spinner.hide();
            debugger;
            if (res.Status) {

              this.PoheaderModel.PH_PURCHASE_INVOICE_NO = res.Data;
              this.PurInvoiceNo = res.Data;
              if (this.PoheaderModel.PH_STATUS == "SUBMITTED") {
                // var str = 'Thank you for submitting the Invoice.Please ensure that the original copy of the submitted invoice reaches at below address within 5 working days.';
                // str += 'To,';
                // str += 'Vendor Help Desk';
                // str += 'FICCI Federation House';
                // str += '1, Tansen Marg';
                // str += 'New Delhi- 110001';

                var str = 'Thank you for submitting the Invoice. ('+this.PurInvoiceNo +')';
                this.GetAllPIDocuments(res.Data);
                this.toasterSer.success(str, null, { closeButton: true, disableTimeOut: true });
                this.spinner.hide();
                resolve(res);
              }
              else {
                this.toasterSer.success('Record saved successfully!');
                this.GetAllPIDocuments(res.Data);
                this.spinner.hide();
                resolve(res);
              }
            }
            else {
              this.toasterSer.error(res.Message);
              this.spinner.hide();
            }


            // if (res.Status) {
            //   this.PurInvoiceNo = res.Data;
            //   resolve(res);
            // }
            // else {

            //   reject(new Error(JSON.stringify(res)));
            // }

          }
        );
    });
    return promise;

  }
  ChangeInvoiceNo() {
    var regex = /^[A-Za-z0-9-/]{1,16}$/;
    if (!regex.test(this.PoheaderModel.PH_VENDOR_INVOICE_NO)) {
      this.toasterSer.warning("Invoice Number format Not valid [must be alphanumeric string with '-' or '/' of length 1 to 16 ]");
      return;
    }
  }


  GetDate(dt) {

    const dArr = dt.split("/");
    let dd = ("0" + dArr[0]).slice(-2);
    let mm = ("0" + dArr[1]).slice(-2);
    let yyyy = ("00" + dArr[2]).slice(-4);

    return `${dd}/${mm}/${yyyy}`;


    // let d = new Date(dt);
    // let ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(d);
    // let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
    // let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
    // //console.log(`${da}-${mo}-${ye}`);

    // return `${da}/${mo}/${ye}`;
  }


  GetDates(dt) {

    const dArr = dt.split("/");
    let dd = ("0" + dArr[1]).slice(-2);
    let mm = ("0" + dArr[0]).slice(-2);
    let yyyy = ("00" + dArr[2]).slice(-4);

    return `${dd}/${mm}/${yyyy}`;
  }

  ConvertYYYYMMDD(dt) {

    const dArr = dt.split("/");
    let dd = ("0" + dArr[1]).slice(-2);
    let mm = ("0" + dArr[0]).slice(-2);
    let yyyy = ("00" + dArr[2]).slice(-4);

    return `${yyyy}/${mm}/${dd}`;
  }


  ValidateDate(docDate) {
    debugger;
    var current = this.GetDate((new Date()).toLocaleDateString('en-US'));
    current = this.ConvertYYYYMMDD(current);
    docDate = this.ConvertYYYYMMDD(docDate);
    var cdt = new Date(current);
    var ddt = new Date(docDate);
    cdt = new Date(cdt.setMonth(cdt.getMonth() - 1));

    if (ddt < cdt) {
      return false;
    }
    return true;
  }



  Savepoheader(Status: any) {
    debugger;


    this.PoheaderModel.Files = this.files;
    //this.PoheaderModel.PH_DOCUMENT_DATE = this.parseDate(this.PoheaderModel.PH_DOCUMENT_DATE);
    //this.PoheaderModel.PH_DOCUMENT_DATE=new Date(this.PoheaderModel.PH_DOCUMENT_DATE).toISOString();

    //this.PoheaderModel.PH_DOCUMENT_DATE=new Date(this.PoheaderModel.PH_DOCUMENT_DATE).toLocaleDateString();

    debugger;

    if (this.PoheaderModel.PH_DOCUMENT_DATE.toString().indexOf("/") <= -1) {

      this.PoheaderModel.PH_DOCUMENT_DATE = (new Date(this.PoheaderModel.PH_DOCUMENT_DATE)).toLocaleDateString('en-US');
      //new Date(this.CreditMemoModel.InvoiceDate); 
      //this.PoheaderModel.PH_DOCUMENT_DATE = this.GetDates(this.PoheaderModel.PH_DOCUMENT_DATE);
    }
    else {
      this.PoheaderModel.PH_DOCUMENT_DATE = this.GetDates(this.PoheaderModel.PH_DOCUMENT_DATE);
    }

    console.log(this.PoheaderModel);


    if (this.validationsHeader()) {
      if (Status == "SUBMITTED") {

        // if (!this.ValidateDate(this.PoheaderModel.PH_DOCUMENT_DATE)) {
        //   this.toasterSer.warning('Invoice Date can not be more than 1 month back.');
        //   return;
        // }

        if (this.PoheaderModel.PH_VENDOR_EMAIL == '') {
          this.toasterSer.warning('Please enter Email');
          return;
        }



        if (!(this.validateEmail(this.PoheaderModel.PH_VENDOR_EMAIL))) {
          this.toasterSer.warning("Email address is invalid");
          return;
        }

        if (this.PoheaderModel.PH_CONTACT_PERSON == '') {
          this.toasterSer.warning('Please enter Contact Person in Ficci');
          return;
        }
        if (this.PoheaderModel.PH_PO_No == '') {
          this.toasterSer.warning('Please enter PO No');
          return;
        }

        if (this.AddressCodeList.length > 0 && this.PoheaderModel.PH_ORDER_ADDRESS_CODE == '') {
          this.toasterSer.warning('Please Select Supplier GSTN');
          return;
        }
        // for (var i = 0, len = this.PoLineList.length; i < len; i++) {
        //   if (this.PoLineList[i].PL_LINE_NO == '' || this.PoLineList[i].PL_LINE_NO == null || this.PoLineList[i].PL_LINE_NO == undefined) {
        //     this.toasterSer.warning('Calculate Tax before submitting Sales Invoice!');
        //     return;
        //   }
        // }


        if (this.files.length <= 0) {
          this.toasterSer.warning('Please upload files!');
          return;
        }

        debugger;

        if (this.files.length > 0) {
          if (this.files.filter(x => String(x.name).includes("PO_") == true).length <= 0) {
            this.toasterSer.warning('Please Upload Purchase Order/Work Order !');
            return;
          }

          if (this.files.filter(x => String(x.name).includes("TI_") == true ).length <= 0) {
            this.toasterSer.warning('Please Upload Tax Invoice !');
            return;
          }

        }

      }

      this.PoheaderModel.PH_STATUS = Status;
      this.PoheaderModel.PH_CREATED_BY = sessionStorage.getItem("UserName");
      if (this.PoLineList.length <= 0) {
        this.toasterSer.warning('purchase Line should not be empty!');
        return;
      }



      console.log(this.PoheaderModel);
      debugger;


      this.spinner.show();

      this.PoheaderModel.purchase_LineModels = this.PoLineList;
      this.SavePOERP()
        .then(res => {
          console.log(res);

        }

          // ).then(resp => {   
          //   this.uploadDocuments(this.PurInvoiceNo,Status)
          // }
        )
        .then(resp => {
          debugger;
          this.spinner.hide();
          this.GetPOHeaderDetails(this.PurInvoiceNo);
        }
        )
        // .then(d=>{
        //   this.GetAllPIDocuments(this.PoheaderModel.PH_PURCHASE_INVOICE_NO);
        // })
        .catch(err => {
          debugger;
          this.spinner.hide();
          console.log(err);
          let result = JSON.parse(err.message);
          console.log(result.Message);
          this.toasterSer.error(result.Message);
        });

    }
  }


  FillHsnDropDown() {
    this.LstHSNSACMaster = this.TempLstHSNSACMaster.filter((S: VMSHSNSACMASTERModel) => S["HSNSAC_GST_GROUP_CODE"] == this.PoLineModel.PL_GST_GROUP_CODE);
  }

  GetAllMasters() {
    let promise = new Promise((resolve, reject) => {
      this.POHeaderSer.GetAllMasters().toPromise()
        .then(
          res => {
            this.TempLstHSNSACMaster = res.Data[0];
            this.LstUomMaster = res.Data[1];
            this.LstGSTGroupCodeMaster = res.Data[2];
            this.LstPLTypeMaster = res.Data[3];
            this.LstNatureOfExpenseMaster = res.Data[4];
            this.LstNatureOfDeductionMaster = res.Data[5];
            this.TempLstNatureOfDeductionMaster = res.Data[5];
            this.LstPIHeaderStructureMaster = res.Data[6];
            this.LstLocationMaster = res.Data[7];
            this.LstDepartmentMaster = res.Data[8];
            this.LstNatureOfDeductionMaster = this.LstNatureOfDeductionMaster.filter(x => x.VENDOR_CODE == sessionStorage.getItem("UserName"));
            this.PoheaderModel.PH_LOCATION_CODE = this.LstLocationMaster[0].LOCATION_CODE;
            this.PoheaderModel.PH_STRUCTURE = this.LstPIHeaderStructureMaster[0].HEADER_STRUCT_CODE;
            resolve('success');
          }
        );
    });
    return promise;
  }

  uploadDocuments(PurchaseInvoiceNo: string, Status) {
    if (this.FileUpload.length > 0) {
      this.spinner.show();
      let formData: FormData = new FormData();
      for (var i = 0; i < this.FileUpload.length; i++) {
        formData.append(this.FileUpload[i].name, this.FileUpload[i]);
      }
      debugger;
      let promise = new Promise((resolve, reject) => {
        this.POHeaderSer.UploadReferenceDoc(PurchaseInvoiceNo, this.PoheaderModel.PH_STATUS, formData).toPromise()
          .then(
            res => {
              if (Status == "SUBMITTED") {
                var str = 'Thank you for submitting the Invoice.Please ensure that the original copy of the submitted invoice reaches at below address within 5 working days.';
                str += 'To,';
                str += 'Vendor Help Desk';
                str += 'FICCI Federation House';
                str += '1, Tansen Marg';
                str += 'New Delhi- 110001';
                this.GetAllPIDocuments(this.PoheaderModel.PH_PURCHASE_INVOICE_NO);
                this.toasterSer.success(str, null, { closeButton: true, disableTimeOut: true });
                this.spinner.hide();
              }
              else {
                this.toasterSer.success('Record saved successfully!');
                this.GetAllPIDocuments(this.PoheaderModel.PH_PURCHASE_INVOICE_NO);
                this.spinner.hide();
              }

              resolve(res);
            }
          );
      });
      return promise;
    }
    else {
      this.toasterSer.success('Record saved successfully!');
      this.spinner.hide();

    }
  }

  DeleteDocument(FileName: string) {
    this.POHeaderSer.DeleteDocument(this.PoheaderModel.PH_PURCHASE_INVOICE_NO, FileName).subscribe(
      data => {
        if (data) {
          this.toasterSer.success(data);
          this.GetAllPIDocuments(this.PoheaderModel.PH_PURCHASE_INVOICE_NO);
        }
        else {
          //alert(data);
        }
      }, error => console.error());
  }

  GetAllPIDocuments(PurchaseInvoiceNo: string) {
    this.files = [];
    this.FileUpload = [];
    this.POHeaderSer.GetAllPIDocuments(PurchaseInvoiceNo).subscribe(
      data => {
        debugger;
        if (data.indexOf('Could not find a part of the path') <= -1) {         
          data.forEach(element => {
            this.files.push({ name: element, DownloadFlag: true })
          });
        }
        console.log(this.files);
      }, error => console.error());

  }
  // validateFile(name: String) {
  //   var ext = name.substring(name.lastIndexOf('.') + 1);
  //   //.xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf
  //   if (ext.toLowerCase() == 'xlsx' || ext.toLowerCase() == 'xls' || ext.toLowerCase() == 'image/*'||ext.toLowerCase() == 'doc' || ext.toLowerCase() == 'docx' || ext.toLowerCase() == 'ppt'|| ext.toLowerCase() == 'pptx' || ext.toLowerCase() == 'txt' || ext.toLowerCase() == 'pdf') {
  //       return true;
  //   }
  //   else {
  //       return false;
  //   }
  // }


  handleFileInput(file: FileList) {
    this.fileToUpload = file.item(0);

    //Show image preview
    let reader = new FileReader();
    reader.onload = (event: any) => {
      this.imageUrl = event.target.result;

      if (this.size > 500000) {//5mb //50kb
        // alert(this.size+"size");
        //boolean true
        this.size_limit = true;
      }
    };
    if (this.size_limit) {
      alert("File Size is more than 5 MB");

    }
    else {
      reader.readAsDataURL(this.fileToUpload);
    }
    // reader.readAsDataURL(this.fileToUpload);
  }


  fileType: string = "";
  uploadFile(event,fileType): void {
    this.fileType = fileType;
    var totalsize = 0;
    debugger;
    for (let index = 0; index < event.length; index++) {
      totalsize += event[index].size;
      //alert(totalsize);
    }

    if (totalsize > 5242880) {
      alert("File Size is more than 5 MB");
      (<HTMLInputElement>document.getElementById("fileinputPurchaseOrder")).value = '';
      (<HTMLInputElement>document.getElementById("fileinputOthers")).value = '';
      (<HTMLInputElement>document.getElementById("fileinputTaxInvoice")).value = '';
      return;
    }
    debugger;
    for (let index = 0; index < event.length; index++) {
      const element = event[index];
      const fileName = this.fileType + '_' + element.name;
      this.files.push({ name: fileName, DownloadFlag: false });
      //this.FileUpload.push(event[index]);

      this.FileUpload.push({ name: fileName, file: event[index] });
    }
    //(<HTMLInputElement>document.getElementById("fileinput")).value = '';

    (<HTMLInputElement>document.getElementById("fileinputPurchaseOrder")).value = '';
    (<HTMLInputElement>document.getElementById("fileinputOthers")).value = '';
    (<HTMLInputElement>document.getElementById("fileinputTaxInvoice")).value = '';
    
    console.log('files', this.files);
    console.log('FileUpload', this.FileUpload);

  }


  deleteAttachment(index) {
    if (confirm('Do you want to delete this file')) {
      var Name = this.files[index].name;
      //var UploadIndex = this.FileUpload.map(function (x) { return x.name; }).indexOf(Name);
      if (this.files[index].DownloadFlag) {
        this.DeleteDocument(Name);
      }
      else {
        this.FileUpload.splice(index, 1);
        this.files.splice(index, 1);
      }
    }
  }


  getFileType(fileName: string): string {
    let fileType = fileName.split('_')[0];
    return (fileType == 'PO' ? 'Purchase Order' : (fileType == 'TI' ? 'Tax Invoice' : 'Others'));
  }


  // onPaste(event: ClipboardEvent) {
  //   // Prevent the default paste behavior
  //   event.preventDefault();

  //   // Get the pasted content
  //   const pastedText = event.clipboardData?.getData('text');

  //   // Define a regular expression for allowed characters (e.g., only letters and numbers)
  //   const filteredText = pastedText?.replace(/[^a-zA-Z0-9-_ ]/g, ''); // Allow only alphanumeric characters and spaces

  //   // Get the input element and set the filtered value
  //   const inputElement = event.target as HTMLInputElement;
  //   inputElement.value = filteredText ?? '';
  // }

  // This method will be triggered on keyup event
  onKeyUp(event: KeyboardEvent) {
    const inputElement = event.target as HTMLInputElement;

    // Use a regular expression to filter out special characters
    // For example, allow only alphanumeric characters and spaces
    const filteredValue = inputElement.value.replace(/[^a-zA-Z0-9-_/ ]/g, '');
    
    // Update the input value with the filtered text
    inputElement.value = filteredValue;
  }


  onKeyUpInv(event: KeyboardEvent) {
    const inputElement = event.target as HTMLInputElement;

    // Use a regular expression to filter out special characters
    // For example, allow only alphanumeric characters and spaces
    const filteredValue = inputElement.value.replace(/[^A-Za-z0-9-/]/g, '');
    
    // Update the input value with the filtered text
    inputElement.value = filteredValue;
  }

}


